import { type IdentifierInputValue } from '@/shared/components/InputFields/SmartInputField';

/**
 * The password an applicant types on the sign-up page (AIMS layout), held in memory only until the
 * sign-up asks for it after the code is verified. Never written to storage: a reload drops it, and
 * the set-password page then simply asks for it. It is tied to the email or phone it was typed
 * with, so it can never land on another person's account.
 */
type Pending = { password: string; identifier: IdentifierInputValue };

const store = new Map<'pending', Pending>();

export const setPendingPassword = (password: string, identifier: IdentifierInputValue) => {
  store.set('pending', { password, identifier });
};

/** The password, once, only for the same email or phone; it is forgotten either way. */
export const takePendingPassword = (identifier?: IdentifierInputValue) => {
  const pending = store.get('pending');
  store.delete('pending');

  if (
    !pending ||
    !identifier ||
    pending.identifier.type !== identifier.type ||
    pending.identifier.value !== identifier.value
  ) {
    return;
  }

  return pending.password;
};
